import { render, staticRenderFns } from "./SynchroLogsListPage.vue?vue&type=template&id=41d7ddf0&"
import script from "./SynchroLogsListPage.vue?vue&type=script&lang=ts&"
export * from "./SynchroLogsListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports